import axios from 'axios';

export function deleteGalleryImage(imageId) {
  return axios.delete(`/api/?entity=gallery&action=deleteImage&imageId=${imageId}`);
}
